import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faCalendar, faSquareXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Advertisement() {
    const [page, setPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    let dark = useSelector((state) => { return state.Darkmode.value });

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const [data, setData] = useState([])

    useEffect(() => {
        setPage(1)
        UpgradeData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/ad', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setData(tmp?.data?.ad ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    let slice_data = data.slice((page - 1) * 20, (page) * 20)

    const [formData, setFormData] = useState({
        TITLE: "", // 광고 이름
        REDIRECT_URL: "", // 리디렉션 URL
        START_DATE: "", // 시작 날짜
        END_DATE: "", // 종료 날짜
        file: '', // 업로드된 파일
    });
    const [imagePreviews, setImagePreviews] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'checkbox') {
            setFormData({ ...formData, [name]: checked });
        } else if (type === 'file') {
            setFormData({ ...formData, file: files });
            handleImagePreview(files);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // 이미지 미리보기 처리 함수
    const handleImagePreview = (files) => {
        const previewArray = Array.from(files).map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result); // 파일의 base64 데이터를 resolve
                };
                reader.readAsDataURL(file); // 파일을 base64로 변환
            });
        });

        Promise.all(previewArray).then((images) => {
            setImagePreviews(images); // 미리보기 이미지들을 저장
        });
    };

    const onSubmit = async () => {
        const formDataObj = new FormData();

        formDataObj.append('adName', formData.TITLE);
        formDataObj.append('adRedirectUrl', formData.REDIRECT_URL); // 리디렉션 URL 추가
        formDataObj.append('start', formData.START_DATE); // 시작 날짜
        formDataObj.append('end', formData.END_DATE); // 종료 날짜
        if (formData.file.length > 0) {
            formDataObj.append("file", formData.file[0]);
        } else {
            alert("이미지를 선택하세요.");
            return;
        }

        await axios.post(process.env.REACT_APP_API + "/api/ad", formDataObj, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setFormData({
                    TITLE: "", // 광고 이름
                    REDIRECT_URL: "", // 리디렉션 URL
                    START_DATE: "", // 시작 날짜
                    END_DATE: "", // 종료 날짜
                    file: '', // 업로드된 파일
                })
                setImagePreviews([])
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <div className='main'>
            <div className='budget-box'>
                <div style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "bold" }}>광고 등록</div>
                <div className='create-img-box'>
                    <div className=''>
                        <div className='budget-2'>
                            <div className='budget-1-3'>이미지 첨부</div>
                            <div className='budget-1-2'>
                                <label htmlFor="file" className="form-control file_form" style={{ display: "block" }}>
                                    {formData.file ? Array.from(formData.file).map(file => file.name).join(', ') : "파일선택"}
                                </label>
                                <input type="file" id="file" name="file" style={{ display: "none" }} multiple accept="image/*" onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>이름</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "300px" }} type="text" name="TITLE" placeholder="광고 이름" value={formData.TITLE || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>연결 URL</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "300px" }} type="text" name="REDIRECT_URL" placeholder="http://example.com" value={formData.REDIRECT_URL || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>시작일</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "150px" }} type="date" name="START_DATE" value={formData.START_DATE || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>종료일</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "150px" }} type="date" name="END_DATE" value={formData.END_DATE || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='ads-btn' onClick={() => onSubmit()}>등록</div>
                    </div>
                    <div className='ads-preImg'>
                        <div>미리보기</div>
                        {
                            imagePreviews.length > 0 &&
                            imagePreviews.map((src, index) => (
                                <img key={index} src={src} alt={`preview ${index}`} className="multipreview" style={{ height: "230px" }} />
                            ))
                        }
                    </div>
                </div>
            </div>
            <div className={`main-box ${darkname}`}>
                <div className={`member-2 ${darkname}`} style={{ width: "1350px" }}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "5%", minWidth: "50px" }}>no.</div>
                        <div style={{ width: "20%", minWidth: "300px" }}>배너 미리보기(비율 4:1)</div>
                        {/* <div style={{ width: "10%", minWidth: "200px" }}>이름</div> */}
                        <div style={{ width: "20%", minWidth: "300px" }}>연결 URL</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>시작일</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>종료일</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>게임 표시</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>쇼핑(한국) 표시</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>쇼핑(필리핀) 표시</div>
                        <div></div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                slice_data.length === 0
                                    ?
                                    <div className='data-nofound'>
                                        <img src='/img/img_nofound.png'></img>
                                        <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {
                                            slice_data.map(function (a, i) {
                                                return (
                                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} setMessage={setMessage} />
                                                )
                                            })
                                        }
                                        <NewPage initialData={data} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, setReload, setMessage }) {
    const [dianModal, setDiaModal] = useState(false)
    const [clickId, setClickId] = useState([])

    const onClickData = () => {
        setClickId(item);
        setDiaModal(true)
    }

    const onSubmitDelete = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/ad/delete", {
            adId: item.id
        }, {
            // headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <>
            <div className={`table-body-tr ${darkname}`} style={{ height: "100px" }}>
                {dianModal && (<DiaModal darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}
                <div className='td' style={{ width: "5%", minWidth: "50px" }}>{item.id}</div>
                <div className='td' style={{ width: "20%", minWidth: "300px" }}><img src={process.env.REACT_APP_IMGAPI + item.ad_img} style={{ width: '95%' }}></img></div>
                {/* <div className='left td' style={{ width: "10%", minWidth: "200px" }}>{item.ad_name}</div> */}
                <div className='onclick left td' style={{ width: "30%", minWidth: "300px" }} onClick={() => window.open(`${item.ad_redirect_url}`)}>{item.ad_redirect_url}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.ad_start}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.ad_end}</div>
                <div className='td' style={{ width: "10%", minWidth: "120px" }}>{item.ad_status === "1" ? "활성화" : "비활성화"}</div>
                <div className='td' style={{ width: "10%", minWidth: "120px" }}>{item.ad_giftishow_status === "1" ? "활성화" : "비활성화"}</div>
                <div className='td' style={{ width: "10%", minWidth: "120px" }}>{item.ad_sodagift_status === "1" ? "활성화" : "비활성화"}</div>
                <div className='td' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                    <div className="upgrade-btn" onClick={() => onClickData()} style={{ backgroundColor: "#003577", color: "#fff" }}>수정</div>
                    <div className="upgrade-btn" onClick={() => onSubmitDelete()}>삭제</div>
                </div>
            </div>
        </>
    )
}

function DiaModal({ darkname, setDiaModal, clickId, setReload }) {
    const [formData, setFormData] = useState({
        adName: clickId.ad_name || '', // 광고 이름
        adUrl: clickId.ad_redirect_url || '', // URL
        startDate: clickId.ad_start || '', // 시작 날짜
        endDate: clickId.ad_end || '', // 종료 날짜
        isActive: clickId.ad_status === '1' ? "active" : "inactive", // 활성화 상태 ("active"/"inactive")
        giftishowIsActive: clickId.ad_giftishow_status === '1' ? "active" : "inactive", // 활성화 상태 ("active"/"inactive")
        sodagiftIsActive: clickId.ad_sodagift_status === '1' ? "active" : "inactive", // 활성화 상태 ("active"/"inactive")
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleModalSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/ad/update', {
            adId: clickId.id,
            adName: formData.adName,
            adRedirectUrl: formData.adUrl,
            start: formData.startDate,
            end: formData.endDate, // "active"/"inactive"를 1/0으로 변환
            adStatus: formData.isActive === "active" ? '1' : '0', // 광고 ID
            giftiAdStatus: formData.giftishowIsActive === "active" ? '1' : '0', // 광고 ID
            sodaAdStatus: formData.sodagiftIsActive === "active" ? '1' : '0', // 광고 ID
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code === 1000) {
                    setDiaModal(false);
                    setReload((e) => !e); // 데이터 새로고침
                }
            })
            .catch((error) => {
                console.error("파일 업로드 중 오류 발생:", error);
            });
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "800px" }}>
                    <div className='modal-1-header'>스킨 이미지 수정</div>

                    <div className='modal-body'>
                        <img
                            src={process.env.REACT_APP_IMGAPI + clickId.ad_img}
                            style={{ width: '600px', marginBottom: "30px" }}
                            alt="기존 이미지"
                        />
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>광고 이름</div>
                            <div style={{ width: "200px" }}>
                                <input
                                    type="text"
                                    name="adName"
                                    value={formData.adName}
                                    onChange={handleInputChange}
                                    placeholder="광고 이름을 입력하세요"
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>URL</div>
                            <div style={{ width: "200px" }}>
                                <input
                                    type="text"
                                    name="adUrl"
                                    value={formData.adUrl}
                                    onChange={handleInputChange}
                                    placeholder="URL을 입력하세요"
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>시작 날짜</div>
                            <div style={{ width: "200px" }}>
                                <input
                                    type="date"
                                    name="startDate"
                                    value={formData.startDate}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>종료 날짜</div>
                            <div style={{ width: "200px" }}>
                                <input
                                    type="date"
                                    name="endDate"
                                    value={formData.endDate}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>게임 표시</div>
                            <div style={{ width: "200px" }}>
                                <select
                                    name="isActive"
                                    value={formData.isActive}
                                    onChange={handleInputChange}
                                    style={{ width: "100%", height: "25px" }}
                                >
                                    <option value="active">활성화</option>
                                    <option value="inactive">비활성화</option>
                                </select>
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>쇼핑(한국) 표시</div>
                            <div style={{ width: "200px" }}>
                                <select
                                    name="giftishowIsActive"
                                    value={formData.giftishowIsActive}
                                    onChange={handleInputChange}
                                    style={{ width: "100%", height: "25px" }}
                                >
                                    <option value="active">활성화</option>
                                    <option value="inactive">비활성화</option>
                                </select>
                            </div>
                        </div>
                        <div className='modal-body-flex' style={{ width: '600px', margin: "0 auto", marginBottom: "15px" }}>
                            <div style={{ width: "130px" }}>쇼핑(필리핀) 표시</div>
                            <div style={{ width: "200px" }}>
                                <select
                                    name="sodagiftIsActive"
                                    value={formData.sodagiftIsActive}
                                    onChange={handleInputChange}
                                    style={{ width: "100%", height: "25px" }}
                                >
                                    <option value="active">활성화</option>
                                    <option value="inactive">비활성화</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={handleModalSubmit}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Advertisement;